import React from 'react';

/**
 * Downward slide open/close using grid-template-rows (0fr ↔ 1fr).
 * Inner wrapper needs min-h-0 for the collapse animation to run reliably.
 */
export default function CollapsibleSlide({
  open,
  children,
  className = '',
  durationClass = 'duration-300',
}) {
  return (
    <div
      className={`grid transition-[grid-template-rows] ease-out motion-reduce:transition-none ${durationClass} ${
        open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
      } ${className}`}
      aria-hidden={!open}
    >
      <div className="min-h-0 overflow-hidden">
        {children}
      </div>
    </div>
  );
}
